import apiRequest from "./api";

export const fetchSuggestions = path => async (query = "") => {
  const { data } = await apiRequest({ path: `/${path}?q=${query}` });
  return data;
};
